namespace ui
{
	export namespace Form
	{

		export interface ISelectDescriptor extends IBasicInputDescriptor
		{
			blank?: string;
			option: {[key: string]: string};
		}

		export class Select
			extends BasicInputField<HTMLSelectElement>
		{
			public readonly	m_Default:	string;

			public constructor( descriptor: ISelectDescriptor, defaultSelection: string = '' )
			{
				super( 'select', descriptor, InputValueTypes.STRING );

				if ( descriptor.blank )
				{
					$( document.createElement( 'option' ) ).text( descriptor.blank ).attr( 'value', '' ).appendTo( this.m_Root );
				}

				for ( const key in descriptor.option )
				{
					if ( descriptor.option[ key ] === undefined )
					{
						continue;
					}

					$( document.createElement( 'option' ) )
					.text( descriptor.option[ key ] )
					.attr( 'value', key )
					.appendTo( this.m_Root );
				}

				this.m_Default	= defaultSelection;
				this.reset();
			}

			public val(): string|null
			{
				const val = this.m_Root.find( 'option:selected' ).val();

				return val === undefined ? null : val as string;
			}

			public value( value: string ): Select
			{
				this.m_StaticAlt.empty().append( this.m_Root.find( 'option:selected' ).text() );

				return super.value( value ) as Select;
			}

			public Static( is_static_now: boolean ): void
			{
				super.Static( is_static_now );

				this.m_StaticAlt.empty().append( this.m_Root.find( 'option:selected' ).text() );
			}

			public reset(): void
			{
				this.value( this.m_Default );
			}

		}

		export interface IMultiSelectDescriptor extends IBasicInputDescriptor
		{
			option: {[key: string]: string};
			size: number;
			multiple?: boolean;
		}

		export class MultiSelect
			extends BasicInputField<HTMLSelectElement, IMultiSelectDescriptor>
		{

			public readonly	Default: string[];

			public constructor( descriptor: IMultiSelectDescriptor, defaultSelection: string[] = [] )
			{
				super( 'select', descriptor, InputValueTypes.ARRAY );

				for ( const value in descriptor.option )
				{
					if (!descriptor.option.hasOwnProperty(value)) {
						continue;
					}
					$( document.createElement( 'option' ) )
						.text( descriptor.option[ value ] )
						.attr( 'value', value )
						.appendTo( this.m_Root );
				}

				this.Default	= defaultSelection;
				this.reset();
			}

			public reset(): void
			{
				this.value( this.Default );
			}

			public Static( is_static_now: boolean ): void
			{
				super.Static( is_static_now );

				this.m_StaticAlt.empty().append( this.m_Root.find( 'option:selected' ).text() );
			}

			public value( value: string[]|null ): MultiSelect
			{
				this.m_StaticAlt.empty().append( this.m_Root.find( 'option:selected' ).text() );

				return super.value( value ) as MultiSelect;
			}

			public val(): string[]
			{
				const val = this.m_Root.find( 'option:selected' ).val();

				return !val ? [] : ( val instanceof Array ? val : [ val as string ] );
			}

			public Initialize(): void
			{
				super.Initialize();

				this.m_Root.attr( 'size', this.Descriptor.size );

				if ( this.Descriptor.multiple )
				{
					this.m_Root.attr( 'multiple', 'multiple' );
				}
			}
		}

	}
}
